let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("i73Fi"), load("4Bp5z"), load("aoJPa")]).then(() => parcelRequire('kaQDe'));